import { useEffect } from "react"

import { v4 } from "uuid"

import { request } from "../Services/Api"
import { captureReferralPromoCode } from "../Utils/referral"

export const useAttributionTracking = () => {
  useEffect(() => {
    captureReferralPromoCode()
    trackVisit()
  }, [])
}

export const trackVisit = async () => {
  const passedRegistration = isPassedRegistration()
  if (passedRegistration) {
    return
  }
  const data = getAttributionData()
  const res = await sendAttributionData(data)
  if (!res.ok) {
    // 401 (no token yet on entry pages) and network blips are expected for this background
    // tracking — skip them so they don't flood Datadog. Real server errors are still reported.
    if (res?.status && res.status !== 401) {
      console.error("Attribution tracking failed:", res?.data)
    }
    return
  }
}

export const sendAttributionData = async (data) => {
  return request.api.post("/user/track-attribution/", data)
}

export const getAttributionData = () => {
  const frontend_user_id = getUserId()
  const urlParams = new URLSearchParams(window.location.search)

  let source = urlParams.get("utm_source")
  let medium = urlParams.get("utm_medium")
  let campaign = urlParams.get("utm_campaign")
  const landing_page_url = window.location.href

  const referrer = document.referrer

  if (!source && referrer) {
    try {
      const refDomain = new URL(referrer).hostname.replace("www.", "")
      source = refDomain
      medium = "referral"
    } catch {
      source = "unknown"
      medium = "referral"
    }
  }

  if (!source && !referrer) {
    source = "direct"
    medium = "none"
  }
  return {
    frontend_user_id,
    source,
    medium,
    campaign,
    landing_page_url
  }
}

export const getUserId = () => {
  let frontend_user_id = findFrontendUserIdInCookies()
  if (!frontend_user_id) {
    frontend_user_id = v4()
    setFrontendUserIdInCookies(frontend_user_id)
  }
  return frontend_user_id
}

const setFrontendUserIdInCookies = (frontend_user_id) => {
  const cookieAge = 60 * 60 * 24 * 365
  const domain = window.location.hostname.includes("localhost") ? "localhost" : ".chargeback.io"
  document.cookie = `frontend_user_id=${frontend_user_id}; path=/; max-age=${cookieAge}; domain=${domain}; SameSite=None; Secure`
}

const findFrontendUserIdInCookies = () => {
  const cookies = document.cookie.split("; ")
  for (let cookie of cookies) {
    const [name, value] = cookie.split("=")
    if (name === "frontend_user_id") {
      return value
    }
  }
  return null
}

export const isPassedRegistration = () => {
  const cookies = document.cookie.split("; ")
  for (let cookie of cookies) {
    const [name, value] = cookie.split("=")
    if (name === "isPassedRegistration" && value === "true") {
      return true
    }
  }
  return false
}

export const setPassedRegistration = () => {
  const cookieAge = 60 * 60 * 24 * 365
  const domain = window.location.hostname.includes("localhost") ? "localhost" : ".chargeback.io"
  document.cookie = `isPassedRegistration=true; path=/; max-age=${cookieAge}; domain=${domain}; SameSite=None; Secure`
}
